import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { goFetch } from "./utilities";

const root = ReactDOM.createRoot(
  document.getElementById("root") ?? document.getElementsByTagName("body")[0]
);
root.render(<App />);

goFetch.configureDefaults({
  defaultErrorHandler: (err, resolve, reject) => {
    alert(err);
    // check error and sign out if 401 or 403 type error
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
